import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import CorrectIcon from '@material-ui/icons/ThumbUp';
import IncorrectIcon from '@material-ui/icons/ThumbDown';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import { img } from '../../config';
import { getResource } from '../../tools';
import "./Verbs.scss";

const useStyles = makeStyles(theme => ({
  // theme: console.log(theme),
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: '50em',
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  menu: {
    maxWidth: '100%',
    minHeight: 450,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& > div': {
      border: '3px solid #C3CCE9',
      width: 400,
      maxWidth: '100%',
      textAlign: 'center',
      cursor: 'pointer',
      borderRadius: 5,
      marginBottom: 5,
      padding: 5,
      background: '#fff',
      '&:hover': {
        background: '#EFF3FA',
      },
    },
    '& img': {
      maxWidth: 400,
      marginBottom: 20,
    },
  },
  cards: {
    '& > h3': {
      textAlign: 'center',
    },
  },
  dict: {
    '& h3': {
      marginBottom: '0.25em',
    },
  },
  dictTrans: {
    textAlign: 'center',
    marginTop: 0,
  },
  tableReg: {
    margin: '0 auto',
    borderCollapse: 'collapse',
    fontSize: '0.85em',
    '& th': {
      border: '1px solid #aaa',
      padding: '0.125em 0.5em',
      width: '33%',
      background: '#e9f1ff',
      color: '#003797',
    },
    '& tr:hover': {
      background: '#fffbf7',
    },
    '& td': {
      border: '1px solid #aaa',
      padding: '0.125em 0.5em',
      width: '33%',
      '&:nth-child(1)': {
        color: '#003797',
      },
      '&:nth-child(2)': {
        color: '#12765d',
      },
      '&:nth-child(3)': {
        color: '#761d04',
      },
    },
  },
  tableIrreg: {
    margin: '0 auto',
    borderCollapse: 'collapse',
    fontSize: '0.85em',
    width: '30em',
    '& th': {
      border: '1px solid #aaa',
      padding: '0.125em 0.5em',
      width: '33%',
      background: '#e9f1ff',
      color: '#003797',
    },
    '& tr:hover': {
      background: '#fffbf7',
    },
    '& td': {
      border: '1px solid #aaa',
      padding: '0.125em 0.5em',
      width: '25%',
      '&:nth-child(1)': {
        color: '#003797',
      },
      '&:nth-child(2)': {
        color: '#12765d',
      },
      '&:nth-child(3)': {
        color: '#761d04',
      },
    },
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    fontFamily: theme.typography.body1.fontFamily,
  },
  incorrect: {
    color: theme.palette.error.main,
  },
  correct: {
    color: theme.palette.success.main,
  },
  done: {
    color: '#1d9021',
    marginRight: 5,
    float: 'right',
  },
  notDone: {
    color: '#ccc',
    marginRight: 5,
    float: 'right',
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {
    tableIrreg: {
      width: '100%',
    },
  }
}));

let timeout1 = 0;
const bg1 = `url("${img('flip-back4.jpg')}")`;
const bg2 = `url("${img('flip-back3.jpg')}")`;

function Verbs(props) {
  const classes = useStyles();
  const [state, setState] = useState('top-menu');
  const [data, setData] = useState([]);
  const [flashcards, setFlashcards] = useState([]);
  const [finished, setFinished] = useState(false);
  const { startStats, action, type } = props.exerciseProps;
  const ref = useRef(null);

  useEffect(() => {
    const url = 'Dictionary/verbs.json'
    getResource(url)
      .then((response) => {
        setData(response);
      }).catch(e => console.log(e));
    init();
    return () => {
      clearTimeout(timeout1);
    }
    // eslint-disable-next-line
  }, []);

  const init = () => {
    action();
    startStats(type);
    setFinished(false);
  }

  const correct = () => {
    action();
    if (flashcards.length > 1) {
      const newFlashcards = [...flashcards];
      ref.current.classList.remove("active");
      timeout1 = setTimeout(() => {
        newFlashcards.shift();
        setFlashcards(newFlashcards);
      }, 100);
    } else {
      setFinished(true);
    }
  }

  const incorrect = () => {
    action();
    ref.current.classList.remove("active");
    if (flashcards.length > 1) {
      const newFlashcards = [...flashcards];
      timeout1 = setTimeout(() => {
        const currentCard = newFlashcards.shift();
        newFlashcards.push(currentCard);
        setFlashcards(newFlashcards);
      }, 100);
    }
  }

  const showFlashcards = () => {
    setFinished(false);
    ref.current && ref.current.classList.remove("active");
    setFlashcards(shuffle(data.irregular.table));
    setState('flashcards');
  }

  const renderFlashcards = () => {
    if (!flashcards.length) return '';
    return (
      <div className={classes.dict}>
        <h3>Irregular Verbs</h3>
        <p className={classes.dictTrans}>czasowniki nieregularne</p>
        {drawCard()}
        {finished && <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={() => setState('flashc-menu')}>Powrót</Button>
        </div>}
      </div>
    );
  }

  const flipCard = () => {
    ref.current.classList.add("active");
  }

  const drawCard = () => {
    const word = flashcards[0];

    return (
      <div className="verbs-flip-cards">
        <div ref={ref}>
          <div className='verbs-flip-card-inner'>
            <div className='verbs-flip-card-front' onClick={flipCard}>
              <div style={{ backgroundImage: bg1 }}>
                <span>{word[3].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}</span>
              </div>
            </div>
            <div className='verbs-flip-card-back'>
              <div style={{ backgroundImage: bg2 }}>
                <span>
                  {word[0].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}<br />
                  {word[1].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}<br />
                  {word[2].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}
                </span>
                {!finished && <Fab size="large" color="secondary" aria-label="add" className="verbs-correct" onClick={correct}>
                  <CorrectIcon />
                </Fab>}
                {!finished && <Fab size="large" color="secondary" aria-label="add" className="verbs-incorrect" onClick={incorrect}>
                  <IncorrectIcon />
                </Fab>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const renderMenu = () => {
    return (
      <div className={classes.menu}>
        <img src={img('Flashcards.jpg')} alt='' />
        <div onClick={() => setState('verbs-reg')}>
          <span>Czasowniki regularne</span>
        </div>
        <div onClick={() => setState('verbs-irreg')}>
          <span>Czasowniki nieregularne</span>
        </div>
        <div onClick={showFlashcards}>
          <span>Fiszki - czasowniki nieregularne</span>
        </div>
      </div>
    );
  }

  const renderReg = () => {
    const reg = data.regular.table;

    return (
      <div className={classes.dict}>
        <h3>Regular verbs</h3>
        <p className={classes.dictTrans}>Czasowniki regularne</p>
        <div className={classes.tableWrap}>
          <table className={classes.tableReg} onMouseMove={action}>
            <thead>
              <tr>
                <th>Infinitive<br />bezokolicznik</th>
                <th>to live<br />to walk</th>
                <th>mieszkać<br />chodzić</th>
              </tr>
            </thead>
            <tbody>
              {reg.map((row, idx) => <tr key={idx}>
                <td>{row[0].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}</td>
                <td>{row[1].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}</td>
                <td>{row[2].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}</td>
              </tr>)}
            </tbody>
          </table>
        </div>
        <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={() => setState('top-menu')}>Powrót</Button>
        </div>
      </div>
    );
  }

  const renderIrreg = () => {
    const reg = data.irregular.table;

    return (
      <div className={classes.dict}>
        <h3>Irregular verbs</h3>
        <p className={classes.dictTrans}>Czasowniki nieregularne</p>
        <div className={classes.tableWrap}>
          <table className={classes.tableIrreg} onMouseMove={action}>
            <thead>
              <tr>
                <th>INFINITIVE<br />forma podstawowa</th>
                <th>PAST SIMPLE<br />czas przeszły</th>
                <th>PAST PARTICIPLE<br />III forma</th>
                <th>POLISH<br />polski</th>
              </tr>
            </thead>
            <tbody>
              {reg.map((row, idx) => <tr key={idx}>
                <td>{row[0].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}</td>
                <td>{row[1].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}</td>
                <td>{row[2].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}</td>
                <td>{row[3].map((line, idx2) => <React.Fragment key={idx2}>{idx2 > 0 && <br />}{line}</React.Fragment>)}</td>
              </tr>)}
            </tbody>
          </table>
        </div>
        <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={() => setState('top-menu')}>Powrót</Button>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.wrapper}>
      <div>
        {state === 'top-menu' && renderMenu()}
        {state === 'verbs-reg' && renderReg()}
        {state === 'verbs-irreg' && renderIrreg()}
        {state === 'flashcards' && renderFlashcards()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export default connect(mapStateToProps)(Verbs);
